import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { motion } from "framer-motion";
import Logo from "./Logo";

export default function ProtectedRoute({ children, requireOnboarded = true }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0510]">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <Logo size={64} />
        </motion.div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
